import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { SkeletonBlockComponent } from '@rma/public/generic/ui/skeleton';
import { ExternalReview } from '@rma/public/profiles/private/domain';
import { ExternalReviewComponent } from '@rma/public/profiles/private/ui-external-review';

@Component({
  selector: 'rma-profile-external-reviews-list',
  imports: [MatButtonModule, RouterModule, SkeletonBlockComponent, ExternalReviewComponent, DialogModule],
  templateUrl: './profile-external-reviews.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileExternalReviewsListComponent {
  private readonly dialog = inject(Dialog);

  public readonly reviews = input<ExternalReview[] | null>([]);
  public readonly profileCode = input<string | null>(null);
  public readonly name = input<string | null>(null);
  public readonly loading = input<boolean | null>(false);

  public onShowDialog(review: ExternalReview): void {
    this.dialog.open(ExternalReviewComponent, {
      panelClass: ['bg-white', 'p-6'],
      maxWidth: '70rem',
      autoFocus: 'first-heading',
      data: {
        review,
      },
    });
  }
}
